module.exports = __webpack_public_path__ + "img/down_point_hover.7fdce5a7.svg";